// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClusterDiscoveryPartition } from './ClusterDiscoveryPartition';
import {
  ClusterDiscoveryPartitionFromJSON,
  ClusterDiscoveryPartitionFromJSONTyped,
  ClusterDiscoveryPartitionToJSON,
  ClusterDiscoveryPartitionToJSONTyped,
} from './ClusterDiscoveryPartition';
import type { ClusterDiscoveryCluster } from './ClusterDiscoveryCluster';
import {
  ClusterDiscoveryClusterFromJSON,
  ClusterDiscoveryClusterFromJSONTyped,
  ClusterDiscoveryClusterToJSON,
  ClusterDiscoveryClusterToJSONTyped,
} from './ClusterDiscoveryCluster';

/**
 *
 * @export
 * @interface ClusterDiscoveryTopology
 */
export interface ClusterDiscoveryTopology {
  /**
   *
   * @type {Array<ClusterDiscoveryCluster>}
   * @memberof ClusterDiscoveryTopology
   */
  clusters?: Array<ClusterDiscoveryCluster>;
  /**
   *
   * @type {Array<ClusterDiscoveryPartition>}
   * @memberof ClusterDiscoveryTopology
   */
  partitions?: Array<ClusterDiscoveryPartition>;
}

/**
 * Check if a given object implements the ClusterDiscoveryTopology interface.
 */
export function instanceOfClusterDiscoveryTopology(
  value: object,
): value is ClusterDiscoveryTopology {
  return true;
}

export function ClusterDiscoveryTopologyFromJSON(
  json: any,
): ClusterDiscoveryTopology {
  return ClusterDiscoveryTopologyFromJSONTyped(json, false);
}

export function ClusterDiscoveryTopologyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterDiscoveryTopology {
  if (json == null) {
    return json;
  }
  return {
    clusters:
      json['clusters'] == null
        ? undefined
        : (json['clusters'] as Array<any>).map(ClusterDiscoveryClusterFromJSON),
    partitions:
      json['partitions'] == null
        ? undefined
        : (json['partitions'] as Array<any>).map(
            ClusterDiscoveryPartitionFromJSON,
          ),
  };
}

export function ClusterDiscoveryTopologyToJSON(
  json: any,
): ClusterDiscoveryTopology {
  return ClusterDiscoveryTopologyToJSONTyped(json, false);
}

export function ClusterDiscoveryTopologyToJSONTyped(
  value?: ClusterDiscoveryTopology | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusters:
      value['clusters'] == null
        ? undefined
        : (value['clusters'] as Array<any>).map(ClusterDiscoveryClusterToJSON),
    partitions:
      value['partitions'] == null
        ? undefined
        : (value['partitions'] as Array<any>).map(
            ClusterDiscoveryPartitionToJSON,
          ),
  };
}
